"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "statusColorMapping", {
    enumerable: true,
    get: function() {
        return statusColorMapping;
    }
});
const statusColorMapping = {
    success: 'green',
    warning: 'orange',
    danger: 'cranberry'
};
